import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {RequestApiService} from 'src/app/services/domain_code/request-api.service';
import {RequestDocumentModel} from './request-document-model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {EmbassyService} from 'src/app/services/embassy.service';

@Component({
    selector: 'logzy-request-documents',
    templateUrl: './request-documents.component.html',
    styleUrls: ['./request-documents.component.scss']
})
export class RequestDocumentsComponent implements OnInit {
    requestDocumentObj: RequestDocumentModel;
    documentList: any;
    errorObj: any = {};
    displayedColumns: string[] = ['original_filename', 'document_size', 'name', 'created_by', 'action'];
    documentGroup: string;

    constructor(private requestService: RequestApiService,
                private route: ActivatedRoute,
                private snackBar: MatSnackBar,
                public embassyService: EmbassyService,
    ) {
    }

    ngOnInit(): void {
        this.resetComponent();
    }

    resetComponent() {
        this.requestDocumentObj = new RequestDocumentModel();

        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.requestDocumentObj.request = params['id'];
                this.getRequestDocuments(params['id']);
            }
        });

        switch (this.requestService?.selectedRequest.request_type.dev_name) {
            case 'one_way':
                this.documentGroup = 'oneway_quote'
                break;
            case 'buy_sell':
                this.documentGroup = 'trade_quote'
                break;
            case 'lease':
                this.documentGroup = 'lease_quote'
                break;
            case 'empty_repo':
                this.documentGroup = 'empty_repo_quote'
                break;
        }
    }

    getRequestDocuments(id) {
        this.requestService.getRequestDocumentsById(id).subscribe({
            next: response => {
                this.documentList = response;
                return response;
            }
        });
    }

    postRequestDocuments() {
        this.requestService.postDocuments(this.requestDocumentObj.getSavePayload()).subscribe({
            next: response => {
                this.snackBar.open("Document uploaded successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                this.resetComponent();
                return response;
            },
            error: error => {
                console.log(error);
                return error;
            }
        });
    }
}
